import axios from "axios";
import moment from "moment";
import {axiosCatchHandler} from "../sharedGlobal";
import SweetToast from "@/SweetToast";

const report = {
  namespaced: true,
  state: {
    report: null,
    type: null,
    schedule: null,
    exporting: false,
  },
  mutations: {
    async setState(state, {report, schedule, type}){
      state.report = report;
      state.type = type;
      state.schedule = schedule;
    },
    async setDates(state, dates){
      state.report.date_range = dates.dateRange;
      state.report.comp_range = dates.compRange;
      state.report.from_date = dates.fromDate ? moment(dates.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
      state.report.to_date = dates.toDate ? moment(dates.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
      state.report.comp_from_date = dates.compFromDate ? moment(dates.compFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
      state.report.comp_to_date = dates.compToDate ? moment(dates.compToDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
    },
  },
  actions: {
    async setDates({state, commit, dispatch}, payload){
      await commit('setDates', payload);
      await dispatch('saveReport', {report: state.report, type: state.type});
    },
    fetchReport: ({commit}, payload) =>
      axios.get(`/ajax/${payload.type}/${payload.id}`)
        .then(({ data }) => commit('setState', {
          report: data.report,
          schedule: data.schedule,
          type: payload.type
        })),
    fetchReportByUUID: ({commit}, payload) =>
      // payload.url is a signed URL carrying the report uuid
      axios.post(payload.url)
      .then(({ data }) => commit('setState', {
        report: data,
        schedules: [],
        type: payload.type
      })),
    saveReport: ({state, commit}, {report, type}) =>
      new Promise((resolve, reject) => {
        axios.post(`/ajax/${type}/${report.id}`, {
            data: report
          })
          .then(({ data }) => {
            commit('setState', {
              report: data.report,
              schedule: data.schedule,
              type: type,
            });
            resolve();
          })
          .catch(
            (e) => axiosCatchHandler(e, ({response}) => reject(response))
          );
      }),
    saveSchedule: ({state, commit, dispatch}, schedule) => {
      const root = true;

      return new Promise((resolve, reject) => {
        if(schedule.id){
          axios.post(`/ajax/reports/schedule/${schedule.id}`, {
              data: schedule
            })
            .then(response => {
              commit('setState', {
                report: state.report,
                schedule: response.data,
                type: state.type
              });

              Promise.all([
                  dispatch('reports/fetchReports', {}, {root}),
                  dispatch('reportSchedules/fetchSchedules', {}, {root}),
                ])
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  reject();
                });
            })
            .catch(
              (e) => this.axiosCatchHandler(e, ({response}) => reject(response.data.errors))
            );
          return;
        }

        axios.post('/ajax/reports/schedule', {
            report_id: state.report.id,
            data: schedule
          }).then(response => {
            commit('setState', {
              report: state.report,
              schedule: response.data,
              type: state.type
            });

            Promise.all([
                dispatch('reports/fetchReports', {}, {root}),
                dispatch('reportSchedules/fetchSchedules', {}, {root}),
              ])
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
          }).catch(
            (e) => axiosCatchHandler(e, ({response}) => reject(response.data.errors))
          );
      });
    },
    generatePDF: async (_, uuid) => {
      const { data } = await axios.post(`/ajax/v2/reports/export/${uuid}`);
      const downloadLink = data.url;

      if (!downloadLink) {
        return SweetToast.fire({
          icon: 'info',
          title: "We're generating your pdf. It will download when it's ready"
        });
      }

      window.location.href = downloadLink;
    },
    exportPDF: ({state}, uuid) => {
      state.exporting = true;
      const newTab = window.open(`/reports/export`);

      // Wait for new tab to load or in most browsers the tab will be blank until the POST request has finished.
      newTab.addEventListener('load', async () => {
        const { data } = await axios.post(`/ajax/reports/export/${uuid}`);
        newTab.location = data.url;

        // We only want to close the new tab if we are using Chrome this is due to how browsers handle
        // downloads differently, for example FF will open the pdf within the tab and not trigger a
        // download and Safari will require the user to allow the site to download the first time.
        if (!!window.chrome) {
          setTimeout(() => newTab.close(), 1000);
        }

        state.exporting = false;
      });
    },
    updateGAVersion: ({commit}, payload) => axios.post('/ajax/reports/update-ga-version', payload)
      .then(({data}) => commit('setState', {report: data.report})),
  },
};

export default report;
